import { default as React, FC } from 'react'
import { format } from 'date-fns'
import cn from 'classnames'
import { TABLE_WIDTHS } from './CycleCounts'
import { ICycleCount } from '../../types/cycle-counts'
import { LocationTypes } from '../../types/location'
import { money } from '../../common/display'

const TypeBadge: FC<{ locationType: string }> = ({ locationType }) => {
  const isBin = locationType === LocationTypes.BIN
  return (
    <div
      style={{
        backgroundColor: isBin ? '#FFF3CD' : '#D1ECF1',
        color: isBin ? '#856404' : '#0C5460',
        padding: '2px 6px',
        borderRadius: 4,
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        display: 'inline-block',
      }}
    >
      {locationType}
    </div>
  )
}

interface IProps {
  cycleCount: ICycleCount
  showTypeColumn: boolean
  onClick: (cycleCount: ICycleCount) => void
}

const CycleCountRow: FC<IProps> = ({ cycleCount, showTypeColumn, onClick }) => {
  return (
    <div
      className="table_tr -fixed-height -link"
      onClick={() => onClick(cycleCount)}
    >
      <div className={`table_td ${TABLE_WIDTHS.STATUS}`}>
        <div
          style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
          className={cn('user-status_badge', {
            active: cycleCount.status === 'completed',
            inactive: cycleCount.status === 'rejected',
          })}
        >
          {cycleCount.status === 'rejected'
            ? 'Recount required'
            : cycleCount.status}
        </div>
      </div>
      {showTypeColumn && cycleCount.location?.locationType && (
        <div className={`table_td ${TABLE_WIDTHS.TYPE}`}>
          <TypeBadge locationType={cycleCount.location.locationType} />
        </div>
      )}
      <div className={`table_td ${TABLE_WIDTHS.LOCATION_CODE}`}>
        {cycleCount.location?.code}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.COUNTED_DATE}`}>
        {format(new Date(cycleCount.countedAt), 'MMM D, YYYY')}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.COUNTED_BY}`}>
        {cycleCount.countedBy?.name}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.APPROVED_BY}`}>
        {cycleCount.completedBy?.name}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.LOCATION_AMOUNT}`}>
        {cycleCount.locationAmount}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.COUNTED_AMOUNT}`}>
        {cycleCount.countedAmount}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.VARIANCE}`}>
        {cycleCount.variance}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.TOTAL_VARIANCE}`}>
        {cycleCount.totalVariancePrice >= 0
          ? money(cycleCount.totalVariancePrice)
          : `-${money(Math.abs(cycleCount.totalVariancePrice))}`}
      </div>
    </div>
  )
}

export default CycleCountRow
